import React from 'react'
import { Button } from '../../../ui/Button'

interface RejectedResultProps {
  onFinish?: () => void
}

const RejectedResult: React.FC<RejectedResultProps> = ({ onFinish }) => {
  return (
    <div className="flex flex-1 h-full">
      <div className="rounded-xl p-10 w-full text-center flex flex-col justify-center items-center">
        <div className="max-w-lg">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            Hemos recibido tu respuesta
          </h2>

          <div className="mb-8">
            <p className="text-gray-600 mb-2">
              Gracias por contarnos tu experiencia.
            </p>
            <p className="text-gray-600">
              Nuestro equipo revisará tu comentario y pronto nos pondremos en
              contacto contigo.
            </p>
          </div>

          <Button
            variant="outline"
            size="default"
            onClick={onFinish}
            className="px-12 py-3 text-blue-500 border-blue-500 hover:bg-blue-50 rounded-full"
          >
            Finalizar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RejectedResult
